import React, { createContext, useContext, useEffect, useState } from "react";

const AccessContext = createContext(null);

const STORAGE_KEY = "abjj_access";

export const AccessProvider = ({ children }) => {
  const [access, setAccess] = useState({ email: null, unlocked: false, newsletter: false });

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setAccess(JSON.parse(raw));
    } catch (e) {
      // ignore
    }
  }, []);

  const persist = (next) => {
    setAccess(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (e) {
      // ignore
    }
  };

  const unlock = (email) => {
    persist({ ...access, email, unlocked: true });
  };

  const subscribeNewsletter = (email) => {
    persist({ email, unlocked: true, newsletter: true });
  };

  const reset = () => {
    persist({ email: null, unlocked: false, newsletter: false });
  };

  return (
    <AccessContext.Provider value={{ access, unlock, subscribeNewsletter, reset }}>
      {children}
    </AccessContext.Provider>
  );
};

export const useAccess = () => {
  const ctx = useContext(AccessContext);
  if (!ctx) throw new Error("useAccess must be used within AccessProvider");
  return ctx;
};
